<template>
  <div>
    <main>
      <v-card class="login-form" v-if="isValid">
        <h4>New Password</h4>
        <v-form @submit.native.prevent="submit()">
          <v-text-field
            label="New Password"
            type="password"
            v-model="formData.password"
            required
            :rules="passwordRules"
          ></v-text-field>
          <v-text-field
            label="Re-enter Password"
            type="password"
            v-model="formData.reenteredPassword"
            required
            :rules="passwordRules"
          ></v-text-field>
          <v-flex class="text-xs-right">
            <v-btn type="submit" dark primary class="margin-off">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-flex>
          <v-alert color="error" class="err" icon="warning" value="true" v-if="err">{{err}}</v-alert>
          <v-alert color="success" class="success" icon="warning" value="true" v-if="success">{{success}}</v-alert>
        </v-form>
      </v-card>
      <v-card v-else class="login-form">
        <h3>Invalid hash</h3>
        <p>This has is not valid. Please try to reset your password again.</p>
      </v-card>
    </main>
  </div>
</template>

<script>
  import webHelper from '../helpers/web';

  export default {
    data: () => ({
      formData: {
        password: '',
        reenteredPassword: '',
      },
      isValid: true,
      err: '',
      success: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6 && v.length <= 35) || 'Password must be longer than 6 and shorter than 35 characters',
      ],
    }),
    methods: {
      async submit() {
        this.err = '';
        if (this.formData.password !== this.formData.reenteredPassword) {
          this.err = 'Passwords don\'t match';
          return;
        }
        const res = await webHelper.post(this, 'user/reset', {
          password: this.formData.password,
          hash: this.$route.params.hash,
        });
        if (res.failed) {
          this.err = 'Failed to reset password.';
          return;
        }
        this.success = 'Password reset successful. Redirecting shortly.';

        this.$cookie.set('uuid', res.sessionHash, { expires: '8h' });
        this.$cookie.set('role', res.role, { expires: '8h' });
        setTimeout(() => {
          this.success = '';
          this.$router.push({ path: '/' });
        });
      },
    },
    async created() {
      const res = await webHelper.get(this, 'user/reset', { hash: this.$route.params.hash });
      if (res.failed) {
        this.isValid = false;
        this.err = 'Failed to validate hash.';
        return;
      }
      this.isValid = res.isValid;
    },
  };
</script>

<style scoped lang="scss">
  main {
    display: flex;
    align-items: center;
    max-width: 500px;
    margin: auto;
    height: 100vh;
  }

  .err {
    margin-bottom: 30px;
  }

  .margin-off {
    margin: 0;
  }

  .login-form {
    margin: 0 auto;
    width: 100%;
    padding: 50px 40px 20px 40px;
    a {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue